import React from 'react';
import { useNavigate } from 'react-router-dom';

interface CounselingCountModalProps {
  isOpen: boolean;
  onClose: () => void;
  remainingCount?: number;
}

const CounselingCountModal: React.FC<CounselingCountModalProps> = ({
  isOpen,
  onClose,
  remainingCount = 0,
}) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const handlePurchaseClick = () => {
    navigate('/purchase');
  };

  return (
    <div className="counseling-count-modal-overlay" onClick={onClose}>
      <div className="counseling-count-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">상담 이용 제한</h2>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-content">
          <div className="warning-icon">⚠️</div>

          <div className="message-section">
            <h3 className="main-message">상담 횟수가 부족합니다</h3>
            <p className="detail-message">
              남은 상담 횟수: <span className="count">{remainingCount}회</span>
            </p>
            <p className="description">더 많은 상담을 이용하시려면 상품을 구매해주세요.</p>
            <p className="description">(매일 첫 로그인 시 상담 가능 횟수 30회로 초기화)</p>
          </div>

          <div className="button-section">
            <button className="purchase-button" onClick={handlePurchaseClick}>
              상품 구매하기
            </button>
            <button className="close-modal-button" onClick={onClose}>
              나중에 하기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounselingCountModal;
